/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, {
      scheduled_message: data,
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      scheduled_message: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getHistory(params = {}) {
    return axios.get(`${this.url}/history`, { params });
  }

  getUpcoming(params = {}) {
    return axios.get(`${this.url}/upcoming`, { params });
  }

  // Helper method to get scheduled messages for a specific contact
  getByContact(contactId, params = {}) {
    return axios.get(this.url, {
      params: { contact_id: contactId, ...params },
    });
  }

  // Helper method to get scheduled messages for a specific conversation
  getByConversation(conversationId, params = {}) {
    return axios.get(this.url, {
      params: { conversation_id: conversationId, ...params },
    });
  }
}

export default new ScheduledMessagesAPI();
